module.exports = __webpack_public_path__ + "static/media/ebarchitects_kabeza202112.25a780c6.jpg";